import React from 'react';
import style from './MenuItemsSkeleton.module.scss';
import cn from 'classnames';

const DEFAULT_SECTIONS = [{ rows: 3 }, { rows: 1 }, { rows: 2 }];

const MenuItemsSkeleton = ({ sections = DEFAULT_SECTIONS }) => (
  <>
    {sections.map((section, sIdx) => (
      <>
        <div
          className={cn(style.headerTitle, sIdx == 0 ? 'mt-2' : 'mt-0')}
        />
        <div className={style.section}>
          {Array.from({ length: section.rows * 3 }).map((_, i) => (
            <div key={i} className={style.tile} />
          ))}
        </div>
      </>
    ))}
  </>
);

export default MenuItemsSkeleton;
